import { mergeModels, useModel, computed, resolveComponent, createElementBlock, openBlock, createCommentVNode, createElementVNode, toDisplayString, createBlock, normalizeStyle, unref, createVNode, withCtx } from "vue";
/* empty css                      */
import { VColorPicker } from "vuetify/components/VColorPicker";
import { VMenu } from "vuetify/components/VMenu";
const _hoisted_1 = { class: "d-flex flex-nowrap align-center g-4 justify-space-between" };
const _hoisted_2 = {
  key: 0,
  class: "v-label"
};
const _hoisted_3 = { class: "d-flex flex-nowrap" };
const _sfc_main = /* @__PURE__ */ Object.assign({
  name: "BanzaColorPicker"
}, {
  __name: "BanzaColorPicker",
  props: /* @__PURE__ */ mergeModels({
    label: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 42
    }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const value = useModel(__props, "modelValue");
    const style = computed(() => {
      return {
        "background-color": value.value,
        "width": `${props.size}px`,
        "height": `${props.size}px`
      };
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        __props.label ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(__props.label) + ":", 1)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3, [
          createElementVNode("div", {
            class: "banza-color-picker c-pointer",
            style: normalizeStyle(unref(style))
          }, [
            createVNode(VMenu, {
              activator: "parent",
              location: "bottom",
              "close-on-content-click": false
            }, {
              default: withCtx(() => [
                createVNode(VColorPicker, {
                  "show-swatches": "",
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event)
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ], 4),
          value.value ? (openBlock(), createBlock(_component_b_icon, {
            key: 0,
            icon: "mdi-close",
            size: 20,
            onClick: _cache[1] || (_cache[1] = ($event) => value.value = null)
          })) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
